let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8TQC3")).then(() => parcelRequire('9iWN4'));